import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
`;

/* ── Hero ── */

export const HeroSection = styled.section`
  background-color: #3487d3;
  padding: 120px 40px 80px;
  display: flex;
  justify-content: center;

  @media (max-width: 900px) {
    padding: 100px 20px 64px;
  }
`;

export const HeroInner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 56px;
  max-width: 1100px;
  width: 100%;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 40px;
    align-items: center;
  }
`;

export const HeroLeft = styled.div`
  position: relative;
  flex: 0 0 520px;
  height: 540px;

  @media (max-width: 1024px) {
    flex: 0 0 440px;
    height: 480px;
  }

  @media (max-width: 900px) {
    flex: none;
    width: 100%;
    max-width: 500px;
    height: 420px;
  }
`;

export const HeroCollage = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
`;

export const CollageImg = styled.img<{ pos: "tl" | "tr" | "bl" | "br" }>`
  position: absolute;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);

  ${({ pos }) =>
    pos === "tl" &&
    `
    top: 0;
    left: 0;
    width: 50%;
    height: 48%;
  `}

  ${({ pos }) =>
    pos === "tr" &&
    `
    top: -24px;
    right: 0;
    width: 46%;
    height: 58%;
  `}

  ${({ pos }) =>
    pos === "bl" &&
    `
    bottom: 0;
    left: 4%;
    width: 44%;
    height: 50%;
  `}

  ${({ pos }) =>
    pos === "br" &&
    `
    bottom: -20px;
    right: 2%;
    width: 48%;
    height: 44%;
  `}
`;

export const FormCard = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  border-radius: 20px;
  padding: 28px 28px;
  width: 310px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.22);
  z-index: 2;

  @media (max-width: 1024px) {
    width: 286px;
    padding: 24px 22px;
  }

  @media (max-width: 900px) {
    width: 310px;
  }
`;

export const FormTitle = styled.h3`
  font-family: "Poppins", sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #000000;
  margin: 0 0 2px 0;
`;

export const FormSubtitle = styled.p`
  font-family: "Aileron", sans-serif;
  font-size: 11px;
  font-weight: 400;
  color: #555555;
  margin: 0 0 14px 0;
  line-height: 1.4;
`;

export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  margin-bottom: 6px;
`;

export const FieldFull = styled.div`
  margin-bottom: 6px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #dddddd;
  border-radius: 6px;
  font-family: "Aileron", sans-serif;
  font-size: 11px;
  color: #333333;
  background: #ffffff;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s ease;

  &::placeholder {
    color: #aaaaaa;
  }

  &:focus {
    border-color: #000000;
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const EyeButton = styled.button`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #aaaaaa;
  display: flex;
  align-items: center;

  &:hover {
    color: #555555;
  }
`;

export const SubmitButton = styled.button`
  margin-top: 10px;
  width: 100%;
  background-color: #000000;
  color: #ffffff;
  border: none;
  border-radius: 24px;
  padding: 10px 16px;
  font-family: "Aileron", sans-serif;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: background 0.2s ease;

  &:hover {
    background-color: #222222;
  }

  &:disabled {
    background-color: #888888;
    cursor: not-allowed;
  }
`;

export const BunnyIcon = styled.img`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
`;

export const CardErrorMessage = styled.p`
  font-family: "Aileron", sans-serif;
  font-size: 10px;
  color: #dc2626;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  padding: 6px 8px;
  margin: 0 0 8px 0;
  line-height: 1.4;
`;

export const VerifyLinks = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
`;

export const TextButton = styled.button`
  background: none;
  border: none;
  font-family: "Aileron", sans-serif;
  font-size: 11px;
  color: #555555;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;

  &:hover {
    color: #000000;
  }
`;

export const VerifySeparator = styled.span`
  font-size: 11px;
  color: #cccccc;
`;

/* ── Hero Right ── */

export const HeroRight = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;

  @media (max-width: 900px) {
    width: 100%;
    max-width: 540px;
    text-align: center;
  }
`;

export const HeroHeading = styled.h1`
  font-family: "Poppins", sans-serif;
  font-size: 36px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 24px 0;
  line-height: 1.15;

  @media (max-width: 1024px) {
    font-size: 30px;
  }

  @media (max-width: 768px) {
    font-size: 26px;
  }
`;

export const ProcessBubblesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const ProcessBubble = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.14);
  border-radius: 12px;
  padding: 11px 16px;
`;

export const ProcessBubbleNumber = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #ffffff;
  color: #3487d3;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ProcessBubbleText = styled.p`
  font-family: "Aileron", sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: #ffffff;
  margin: 0;
  line-height: 1.4;
`;

/* ── Gym section wrapper ── */

export const GymWrapper = styled.div`
  width: 100%;
  background-color: #ffffff;
`;

/* ── Footer ── */

export const FooterBox = styled.div`
  width: 100%;
`;
